import { Component, Input } from '@angular/core';
import {
  IOdbBillProductSplit,
  OdbCoverDetailDivisionType,
} from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-usage-and-otc-product-split',
  templateUrl: './odb-usage-and-otc-product-split.component.html',
  standalone: false,
})
export class OdbUsageAndOtcProductSplitComponent {
  @Input() productSplit: Array<IOdbBillProductSplit>;
  @Input() totalAmount: string;
  @Input() category: 'usage' | 'oneTimeCharge';
  @Input() divisionType: OdbCoverDetailDivisionType;
  @Input() billingAccountNumber: string;
  @Input() documentReference: string;
  @Input() filteredProductSplit: Array<IOdbBillProductSplit>;

  get showSubTotals() {
    return this.productSplit.length > 1;
  }
}
